module.exports = __webpack_public_path__ + "img/pure and righteous crow tengu.daf77beb.png";